import React from "react"
import {
  Box,
  Typography,
  Button,
} from "@mui/material"
import { useDialog } from "common/DialogProvider"
//import { useDialog } from "@/providers/DialogProvider"

type DialogShowcaseProps = {
    size: "small" | "medium"
}

const DialogShowcase: React.FC<DialogShowcaseProps> = ({size}) => {
  const { openDialog } = useDialog();
  
  const successDialog = () => {
    openDialog({
      type: "success",
      title: "Success",
      message: "This is a success dialog",
    })
  }

  const infoDialog = () => {
    openDialog({
      type: "info",
      title: "Info",
      message: "This is an info dialog",
    })
  }

  const confirmDialog = () => {
    openDialog({
      type: "confirm",
      title: "Confirm",
      message: "This is a confirm dialog",
      confirmButton: {
        confirmLabel: "Confirm",
        handleConfirm: (message) => {
          console.log("Confirmed", message)
          message.handleClose(message)
        }
      },
      cancelButton: {
        cancelLabel: "Cancel",
        handleCancel: (message) => {
          console.log("Cancelled", message)
          message.handleClose(message)
        }
      }
    })
  }

  const errorDialog = () => {
    openDialog({
      type: "error",
      title: "Error",
      message: "This is an error dialog",
    })
  }

  const warningDialog = () => {
    openDialog({
      type: "warning",
      title: "Warning",
      message: "This is a warning dialog",
    })
  }

  return (<>
    <Typography className="text-xl font-bold">Dialogs</Typography>
    <Box display={"flex"} flexDirection={"row"} gap={2}>
        <Button variant="contained" color="info" size={size} onClick={infoDialog}>
          Info Dialog
        </Button>
        <Button variant="contained" color="success" size={size} onClick={successDialog}>
          Success Dialog
        </Button>
        <Button variant="contained" color="primary" size={size} onClick={confirmDialog}>
          Confirm Dialog
        </Button>
        <Button variant="contained" color="error" size={size} onClick={errorDialog}>
          Error Dialog
        </Button>
        <Button variant="contained" color="warning" size={size} onClick={warningDialog}>
          Warning Dialog
        </Button>
    </Box>
  </>)
}

export default DialogShowcase
